import React from 'react';

class RowErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  
  render() {
    if (this.state.hasError) {
      return (
        <div className="admin-error-message">
          <strong>Error loading expanded row.</strong>
          <div>{this.state.error ? this.state.error.toString() : ''}</div>
          <div>Check browser console for details.</div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default RowErrorBoundary;
